import { render, staticRenderFns } from "./AddConfig.vue?vue&type=template&id=4b0a769e&scoped=true"
import script from "./AddConfig.vue?vue&type=script&lang=js"
export * from "./AddConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0a769e",
  null
  
)

export default component.exports